// Single source of truth for the Active/Inactive lifecycle flag carried on an
// event record (the Mock Interviews module is the first consumer).
//
// "Inactive" retires a record from the listings without deleting it, so the
// evaluations already recorded against it survive. The API mirrors these
// values in event.service.js (normalizeStatus) — keep the two in step.

export const STATUS_ACTIVE = "Active";
export const STATUS_INACTIVE = "Inactive";

export const STATUSES = [STATUS_ACTIVE, STATUS_INACTIVE];

// `color` is the accent (dot, badge text); `bg`/`border` are the soft chip.
const STATUS_META = {
  [STATUS_ACTIVE]: { label: "Active", color: "#16a34a", bg: "#f0fdf4", border: "#bbf7d0" },
  [STATUS_INACTIVE]: { label: "Inactive", color: "#6b7280", bg: "#f9fafb", border: "#e5e7eb" },
};

// Rows saved before the field existed have no status at all — they read as
// Active, matching how the API filters them.
export const normalizeStatus = (value) =>
  STATUSES.find((s) => s.toLowerCase() === String(value || "").trim().toLowerCase()) ||
  STATUS_ACTIVE;

export const getStatusMeta = (value) => STATUS_META[normalizeStatus(value)];

// react-select options for the form.
export const statusOptions = STATUSES.map((value) => ({
  value,
  label: STATUS_META[value].label,
}));
